import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowOutwardRounded, MailOutlineRounded } from '@mui/icons-material';
import './AboutPage.css';

const socialChannels = [
  { name: 'Instagram', detail: '@hisab_kitab_app', url: 'https://www.instagram.com/hisab_kitab_app' },
  { name: 'YouTube', detail: '@hisabkitabapp', url: 'https://youtube.com/@hisabkitabapp' },
  { name: 'Telegram', detail: '@hisabkitabapp', url: 'https://t.me/hisabkitabapp' },
  { name: 'WhatsApp', detail: 'Hisab Kitab channel', url: 'https://whatsapp.com/channel/0029Va5gOSW8F2p9ueN8Iq22' },
  { name: 'X', detail: '@track_expenses', url: 'https://x.com/track_expenses' },
];

export default function AboutPage() {
  return <div className="hk-about">
    <section className="hk-page-hero">
      <div className="hk-wrap">
        <Link className="hk-breadcrumb" to="/">Home / About Us</Link>
        <div className="hk-about-intro"><div>
        <span className="hk-eyebrow">THE ORGANIZATION BEHIND HISAB KITAB</span>
        <h1>We are<br /><em>Fimly Innovations.</em></h1>
        <p>We develop, operate, and support Hisab Kitab, a personal finance and expense management app.</p>
        <a className="hk-text-link hk-about-contact-link" href="#contact">Get in touch <ArrowOutwardRounded fontSize="small" /></a>
        </div><div className="hk-about-logo"><img src="/company/fimly-innovations.jpg" alt="Fimly Innovations logo" width="200" height="200" /></div></div>
      </div>
    </section>

    <div className="hk-wrap hk-page-content">
      <section className="hk-about-story" aria-labelledby="about-heading">
        <div><span className="hk-eyebrow">ABOUT US</span><h2 id="about-heading">Everyday finances.<br />Made simpler.</h2></div>
        <div>
          <p>At Fimly Innovations, we build digital products that help people organize their everyday finances, from personal records to shared expenses with family and friends.</p>
          <p>Our app, Hisab Kitab, brings expenses, income, investments, and loans together in one place. It helps individuals and groups keep track of their money and understand their spending.</p>
          <Link className="hk-text-link" to="/">Explore Hisab Kitab <ArrowOutwardRounded fontSize="small" /></Link>
        </div>
      </section>

      <section className="hk-about-contact" id="contact" aria-labelledby="contact-heading">
        <span className="hk-eyebrow">LET’S TALK</span>
        <h2 id="contact-heading">Contact Fimly Innovations</h2>
        <p>For product support, account questions, technical issues, or feedback, reach our team by email.</p>
        <div className="hk-about-contact-grid">
          <article className="hk-about-email">
            <MailOutlineRounded aria-hidden="true" />
            <h3>Email us</h3>
            <a href="mailto:support@hisabkitab-app.com">support@hisabkitab-app.com</a>
            <p>Contact our team about Hisab Kitab or Fimly Innovations.</p>
          </article>
          <article className="hk-about-resources">
            <h3>Helpful links</h3>
            <Link to="/help">Hisab Kitab Support <ArrowOutwardRounded fontSize="small" /></Link>
            <Link to="/policy">Privacy Policy <ArrowOutwardRounded fontSize="small" /></Link>
            <a href="https://hisabkitab-app.com">hisabkitab-app.com <ArrowOutwardRounded fontSize="small" /></a>
          </article>
        </div>
      </section>

      <section className="hk-about-social" aria-labelledby="social-heading">
        <span className="hk-eyebrow">STAY CONNECTED</span>
        <h2 id="social-heading">Find Hisab Kitab online</h2>
        <p>Follow our official channels for app news and updates. For account-specific help, please use the support email above.</p>
        <div className="hk-about-social-grid">
          {socialChannels.map(channel => <a key={channel.name} href={channel.url} target="_blank" rel="noopener noreferrer">
            <span><strong>{channel.name}</strong><small>{channel.detail}</small></span>
            <ArrowOutwardRounded fontSize="small" />
          </a>)}
        </div>
      </section>
    </div>
  </div>;
}
